import { defineComponent, ref } from 'vue'
import { Overlay } from '@dustess/cf-design-mobile'
import styles from './index.module.scss'

export default defineComponent({
  name: 'MkFooterShare',
  props: {
    tips: {
      type: String,
      default: '点击右上角，即可直接分享到企微或微信中',
    },
  },
  setup(props, { slots }) {
    const show = ref(false)
    const handleShow = () => {
      show.value = !show.value
    }
    return () => (
      <>
        <div class={`${styles['mk-footer-share']} mk-bg-white flex-c`}>
          <button class={'flex-1 mk-text-white mk-bg-primary mk-fs-16'} onClick={handleShow}>
            <span>分享</span>
          </button>
        </div>
        <Overlay show={show.value} onClick={handleShow}>
          <img
            src={require('./images/yqf_share_remind.png')}
            class={styles['share-popup__remind']}
          />
          <div class={`${styles['share-popup__content']} mk-fs-14 mk-bg-white`}>{ slots.default ? slots.default() : props.tips }</div>
        </Overlay>
      </>
    )
  },
})
